<template>
  <div>
    <vue-headful
    title="Dashboard | Account Settings"
    description="Dashboard | Account Settings"
/>

<div v-if="loading" class="loader" style="margin: 100px auto;">
  <br><br>
  <div>
    <ul>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
      <li>
        <svg viewBox="0 0 90 120" fill="currentColor">
          <path d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z"></path>
        </svg>
      </li>
    </ul>
  </div><span>Loading</span>
</div>


    <div v-if="!loading" class="sc-kEYyzF grKTOC">
      <div class="sc-kAdXeD jwoEpG" style="padding: 0px 0px 30px 0px!important">
         <div class="sc-bvTASY jPMoWD">
            <div class="sc-cFlXAS WflZx">
               <div style="position: relative;">

                <div>
                        <div class="card border-light shadow-soft" style="margin-bottom:20px;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
                          <div class="card-body p-4 p-lg-3">
                                  <div class="row">
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Full Name</label>
                                              <div class="input-group mb-2">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-user-alt"></i></span>
                                                  </div>
                                                  <input v-model="propsdata[0].name" name="name" class="form-control" placeholder="eg. John Doe" type="text">
                                              </div>
                                              <button v-if="!saving" @click="guardarname" style="width: 100%;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-paper-plane"></i></span>Save Name</button>
                                              <button v-if="saving" style="width: 100%;background:#04a677!important;border-color:#04a677!important;" class="btn btn-primary animate-up-2"><span class="mr-2"><i class="fas fa-check"></i></span>Saved</button>
                                          </div>
                                      </div>
                                      <div class="col-12">
                                          <div class="form-group">
                                              <label class="form-label text-dark">Email Address</label>
                                              <div class="input-group mb-2">
                                                  <div class="input-group-prepend">
                                                      <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                                  </div>
                                                  <input :value="propsdata[0].email" name="name" class="form-control" type="text" disabled>
                                              </div>
                                          </div>
                                          <p>Use this email to log in to your Documentify account and receive notifications.</p>
                                      </div>
                                      <!-- <div v-if="propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end !== 'yes' && propsdata[0].canceled !== 'yes'" class="col-12">
                                          <hr>
                                          <div v-if="!canceled">
                                            <h4>Cancel Subscription</h4>
                                            <p>You can cancel your subscription whenever you want.</p>
                                            <p>Note: You will lose all access and rights of your documents, including all the premium features.</p>
                                            <button v-if="!cancelling" data-toggle="modal" data-target="#modal-cancel" class="btn btn-danger animate-up-2">Cancel Subscription</button>
                                            <button v-if="cancelling" class="btn btn-danger animate-up-2"><i class="fas fa-spinner"></i> Cancelling</button>
                                            <p v-if="cancellation_error" class="mt-3" style="color:red;">Cancellation failed. Please contact us at support@documentify.com or in our <a href="https://documentify.com/contact" target="_blank" style="color: red; text-decoration: underline;">contact page</a>.</p>
                                          </div>
                                          <div v-else>
                                            <h4>Subscription Canceled</h4>
                                            <p>You can subscribe again anytime by clicking the button below.</p>
                                            <a :href="'/choose-plan/'+propsdata[0].unique_id" class="btn btn-success animate-up-2">Subscribe Again</a>
                                          </div>
                                      </div>
                                      <div v-else-if="(propsdata[0].paid === 'yes' && propsdata[0].cancel_at_period_end === 'yes') || propsdata[0].canceled === 'yes'" class="col-12">
                                        <hr>
                                        <h4>Subscription Canceled</h4>
                                        <p>You can subscribe again anytime by clicking the button below.</p>
                                        <a :href="'/choose-plan/'+propsdata[0].unique_id" class="btn btn-success animate-up-2">Subscribe Again</a>
                                      </div> -->
                                  </div>
                          </div>
                      </div>

<div v-if="propsdata[0].paid !== 'yes'">
  <div class="card border-light shadow-soft" style="margin-bottom:20px;padding: 10px;border-left: .0625rem solid rgba(243,247,250,.05); border-right: .0625rem solid rgba(243,247,250,.05); border-bottom: .0625rem solid rgba(243,247,250,.05); border-top: 0; border-radius: 0 0 .5rem .5rem;">
    <div class="card-body p-4 p-lg-3">
      <div class="row">
        <div class="col-12 col-md-6 mb-lg-0">
          <h3 class="mb-3">Free Account</h3>
          <p class="text-muted mb-4">You are on the free plan. You can preview and generate documents. Upgrade to download your documents & premium features.</p>
        </div>
        <div class="col-12 col-md-6 d-flex align-items-center justify-content-md-end">
          <a :href="'/choose-plan/'+propsdata[0].unique_id" class="btn btn-md btn-pricing-plan animate-up-2" style="color: #ffffff; background-color: #0949b3; border-color: rgb(255, 255, 255);"><svg width="24" height="24" fill="#ffffff" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" class="sc-eNQAEJ bqIowC"><path d="M5 12.5H15V14H5V12.5Z M5 11L4 7L8 8L10 4L12 8L16 7L15 11H5Z"></path></svg>
                Upgrade Now</a>
        </div>
      </div>
    </div>
  </div>
</div>

                  </div>


             </div>
          </div>
       </div>
    </div>

    <!-- MODAL CANCEL -->
    <!-- <div class="modal fade" id="modal-cancel" tabindex="-1" role="dialog" aria-labelledby="modal-cancel" aria-hidden="true">
       <div class="modal-dialog modal-dialog-centered" role="document">
           <div class="modal-content">
               <div class="modal-header">
                   <h6 class="modal-title">Do you really want to cancel your subscription?</h6>
                   <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                       <span aria-hidden="true">&times;</span>
                   </button>
               </div>
               <div class="modal-footer">
                   <button v-if="!cancelling" @click="cancelsubscription" type="button" data-dismiss="modal" aria-label="Close" class="btn btn-sm btn-success">Yes, I want to cancel my subscription.</button>
                   <button v-if="cancelling" class="btn btn-sm btn-success">Cancelling...</button>
                   <button type="button" class="btn btn-link text-danger ml-auto" data-dismiss="modal">Close</button>
               </div>
           </div>
       </div>
   </div> -->

  </div>
  </div>

</template>

  <script>
  export default {
    props:['propsdata'],
    data() {
      return {
        loading: true,
        billing: [],
        saving: false,
        cancelling: false,
        canceled: false,
        cancellation_error: false
      };
    },
    methods: {
      guardarname(){
        this.saving = true;
        axios.post('/dashboard/enviar-account.php', {
          name: this.propsdata[0].name
          })
          .then(response => {
            this.invoices = response.data;
            this.saving = false;
        })
          .catch(function (error) {
            console.log(error);
          });
      },
      // cancelsubscription(){
      //   this.cancellation_error = false;
      //   this.cancelling = true;
      //   axios.post('/user-cancel-subscription', {
      //     token: lukastoken
      //     })
      //     .then(response => {
      //       this.cancelling = false;
      //       this.canceled = true;
      //       this.propsdata[0].cancel_at_period_end = 'yes';
      //   })
      //     .catch((error) => {
      //       console.log(error);
      //       this.cancelling = false;
      //       this.cancellation_error = true;
      //     });
      // }
    },
    mounted() {
      this.$emit('updateprops');
      axios.post('/dashboard/cargar-billing.php', {
        })
        .then(response => {
          this.billing = response.data;
          this.loading = false;
      })
        .catch(function (error) {
          console.log(error);
        });
    }
  };
  </script>



// WEBPACK FOOTER //
// src/account.vue